import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IResponse } from "App/Modules/Models";
import type { ILocalesRepository } from "./ILocalesRepository";

export default class LocalesRepository implements ILocalesRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAllLocales(): Observable<IResponse<string[]>> {
        return this.httpService.get<string[]>("locales");
    }
}

module("mmRepositories").service("irLocalesRepository", LocalesRepository);
